module.exports = __webpack_public_path__ + "static/report/img/hawkeye.95394474.jpg";